import { render, staticRenderFns } from "./ExamTakerProfileDetail.vue?vue&type=template&id=13cdf46b&scoped=true"
import script from "./ExamTakerProfileDetail.vue?vue&type=script&lang=js"
export * from "./ExamTakerProfileDetail.vue?vue&type=script&lang=js"
import style0 from "./ExamTakerProfileDetail.vue?vue&type=style&index=0&id=13cdf46b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cdf46b",
  null
  
)

export default component.exports